// import caIssueImg from '../../images/services/ca-issue.jpg';
import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const IndependentCharteredAccountantToTheIssue = () => {
  const serviceData = {
    title: "Independent Chartered Accountant Certification Services",
    heading: "Independent Chartered Accountant Certification Services",
    image:
      subTopicImages["Independent Chartered Accountant Certification Services"],
    intro:
      "Professional certifications & confirmations required during the IPO process",
    description: [
      "Throughout the IPO lifecycle, regulators, merchant bankers and investors require independent professional certifications from Chartered Accountants to validate financial and regulatory information.",
      "We provide Independent Chartered Accountant certification services in accordance with Indian professional and regulatory standards.",
    ],
    services: [
      {
        title: "Certification Framework",
        list: [
          "the Companies Act",
          "SEBI regulations (as applicable)",
          "ICAI standards & guidance notes",
          "professional ethics & independence norms",
        ],
        extraInfo:
          "These services are rendered only in permitted areas and subject to eligibility, independence and regulatory guidelines.",
      },
      {
        title: "Examples of Certification Areas (as applicable)",
        list: [
          "certification of financial information or statements included in offer documents",
          "reporting for restated financial statements (with statutory auditors, where applicable)",
          "certifications relating to net worth, capital structure or financial position",
          "confirmations relating to specific financial disclosures",
          "regulatory compliance-related financial certifications",
        ],
      },
    ],
    research:
      "All certifications are issued strictly within the scope permitted to practising Chartered Accountants in India, and in coordination with other intermediaries involved in the IPO process, wherever required.",
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      projects={serviceData.benefits}
    />
  );
};

export default IndependentCharteredAccountantToTheIssue;
